(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-pro-shell"] && !Shopify.designMode) return;
  try {
    
(function(){
 function init(){
  var bar=document.getElementById('mbn-sticky'),footer=document.getElementById('main-cart-footer'),items=document.getElementById('main-cart-items');
  if(!bar||!footer||!items)return;
  var button=bar.querySelector('button'),price=document.getElementById('mbn-sticky-price'),checkout=document.getElementById('checkout'),cartItems=document.querySelector('cart-items'),title=document.querySelector('.mbn-ch-title');
  function sync(){
   var empty=cartItems.classList.contains('is-empty'),busy=items.classList.contains('cart__items--disabled'),total=footer.querySelector('.totals__total-value');
   if(total)price.textContent=total.textContent;
   button.disabled=empty||busy;
   if(title)title.textContent=empty?title.dataset.empty:title.dataset.filled;
   var rect=checkout?checkout.getBoundingClientRect():null;
   bar.hidden=empty||!rect||window.matchMedia('(min-width:750px)').matches||(rect.top>=0&&rect.bottom<=document.documentElement.clientHeight);
  }
  new MutationObserver(sync).observe(footer,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['class']});
  new MutationObserver(sync).observe(items,{attributes:true,attributeFilter:['class']});
  new MutationObserver(sync).observe(cartItems,{attributes:true,attributeFilter:['class']});
  if(checkout&&'IntersectionObserver' in window)new IntersectionObserver(sync,{threshold:[0,1]}).observe(checkout);
  window.addEventListener('resize',sync,{passive:true});window.addEventListener('scroll',sync,{passive:true});sync();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mbn-bf-worlds"] && !Shopify.designMode) return;
  try {
    
function initBfWorld(root){
 if(root.dataset.ready) return;root.dataset.ready='true';
 const buttons=Array.from(root.querySelectorAll('[data-bf-scene]'));
 buttons.forEach(button=>button.addEventListener('click',()=>{
  buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
  root.querySelectorAll('[data-bf-panel]').forEach(p=>p.hidden=p.dataset.bfPanel!==button.dataset.bfScene);
 }));
}
document.querySelectorAll('[data-bf-world]').forEach(initBfWorld);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-bf-world]').forEach(initBfWorld));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mbn-cart-gifts"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mbn-cart-gifts')){
 customElements.define('mbn-cart-gifts',class extends HTMLElement{
  connectedCallback(){
   if(typeof subscribe==='function')this.unsubscribe=subscribe(PUB_SUB_EVENTS.cartUpdate,()=>this.refresh());
  }
  disconnectedCallback(){if(this.unsubscribe)this.unsubscribe();if(this.controller)this.controller.abort();}
  async refresh(){
   if(this.controller)this.controller.abort();
   this.controller=new AbortController();
   try{
    const url=new URL(window.location.href);url.searchParams.set('section_id',this.dataset.sectionId);
    const response=await fetch(url,{signal:this.controller.signal});if(!response.ok)return;
    const html=new DOMParser().parseFromString(await response.text(),'text/html');
    const content=html.querySelector('mbn-cart-gifts');if(content)this.innerHTML=content.innerHTML;
   }catch(error){if(error.name!=='AbortError')console.warn('Gift suggestions could not refresh.');}
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mbn-coll-products2"] && !Shopify.designMode) return;
  try {
    
function setupBfSale(root){
 if(root.dataset.bfReady)return;root.dataset.bfReady='true';
 const buttons=root.querySelectorAll('[data-bf-filter]'),cards=root.querySelectorAll('[data-bf-reduced]');
 function filter(mode){
  buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.bfFilter===mode)));
  cards.forEach(c=>c.hidden=mode==='sale'&&c.dataset.bfReduced!=='true');
 }
 buttons.forEach(b=>b.addEventListener('click',()=>filter(b.dataset.bfFilter)));
 document.querySelectorAll('[data-bf-shop-sale]').forEach(a=>a.addEventListener('click',()=>filter('sale')));
 document.querySelectorAll('[data-bf-shop-all]').forEach(a=>a.addEventListener('click',()=>filter('all')));
}
document.querySelectorAll('[data-bf-sale-grid]').forEach(setupBfSale);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-bf-sale-grid]').forEach(setupBfSale));

  } catch(e) { console.error(e); }
})();
})();
